// extracted by mini-css-extract-plugin
export default {"formErrorError":"VisitScreen_formErrorError__kLHQq","login":"VisitScreen_login__kaAKw","mainwrapper":"VisitScreen_mainwrapper__UdCeS"};